jQuery.expr[":"].Contains = jQuery.expr.createPseudo(function(arg) {
  return function( elem ) {
    return jQuery(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
  };
});


var business = {

	categories: [],

	defaults: {

		container: null,
		clone: null,
		page_limit: 10,
		pagination: true,
		api_token: "digistorm",
		api_url: "https://eduapp.com.au/api/v4/"

	},
	settings: {},

	init: function(settings) {

		// merge settings with defaults
		business.settings = $.extend({}, business.defaults, settings);

		// fetch business categories
		business.get.business_categories();

	},

	// fetch businesses through the api
	fetch: function(method, params, id) {

		// merge params with api token
		params = $.extend({}, params, {
			tk: business.settings.api_token
		});

		// check for id
		if (id != undefined) {

			// set the id
			id = "/" + id;

		} else {

			// no id, therfore set as blank so the api call does not break
			id = "";

		}

		// fetch data
		return $.ajax({

			url: business.settings.api_url + method + id + '.jsonp',
			type: "GET",
			dataType: "jsonp",
			data: params

		});

	},

	get: {

		business_categories: function(params, id) {

			// fetch business categories
			var business_categories = business.fetch("businesscategories");

			business_categories.success(function(categories) {

				var total_businesses = 0;

				// loop through each category
				$.each(categories, function(index, category) {

					// only add non-empty categories
					if (category.total > 0) {

						total_businesses = total_businesses + category.total;

						// save category to array
						business.categories.push(category);

						// create option
						var category_clone = $(business.settings.container).find('.business-categories-clone').find(':first').clone(true);

						category_clone.find('.category-title').text(category.name);
						category_clone.attr('category-id', category.id);

						// set category text based on count
						var category_text = " business";

						if (category.total > 1) {
							category_text = " businesses";
						}

						category_clone.find('.category-count').text(category.total + category_text);

						// add categories to category dropdown
						$(business.settings.container).find('.business-categories').append(category_clone);

						// get first business from category

						var business_data = business.get.businesses({
							business_category_id: category.id
						});

						business_data.success(function(data) {

							if (data[0].logo) {
								category_clone.find('.category-logo').find('img').attr('src', data[0].logo);
							} else {
								// console.log("elese")
								// category_clone.find('.category-logo').html("<i style='width:100%' class='fa fa-th fa-4'></i>");
							}

						});

					}

				});

				$(business.settings.container).find('.business-category:first').find('.category-count').text(total_businesses + " businesses");

				business.controls();

			});

		},

		businesses: function(params, id) {

			if (params.business_category_id != "all") {

				// return only needed category
				return business.fetch("businesses", params, id);

			} else {

				// return all
				return business.fetch("businesses");

			}

		}

	},

	print: function(category, search) {

		if (category == undefined) {

			// get first businesses
			var business_data = business.get.businesses({
				business_category_id: business.categories[0].id
			});

		} else {

			// remove current businesses
			$(business.settings.container).find('.business').each(function() {
				$(this).remove();
			});

			// get business data
			var business_data = business.get.businesses({
				business_category_id: category
			});

		}

		business_data.success(function(data) {

			$.each(data, function(index, info) {

				// create clone
				var current_clone = $(business.settings.clone).find(":first").clone();


				/*
				 * Set Business Values
				 */
				current_clone.find('.business-name').text(info.name);
				current_clone.find('.business-body').html(info.body);
				current_clone.find('.business-contact').html('<i class="fa fa-user"></i> ' + info.contact);
				if (info.mobile) {
					current_clone.find('.business-mobile').html('<i class="fa fa-mobile"></i> ' + info.mobile).attr('href', 'tel:' + info.mobile);
				}
				if (info.phone) {
					current_clone.find('.business-phone').html('<i class="fa fa-phone"></i> ' + info.phone).attr('href', 'tel:' + info.phone);
				}
				if (info.email) {
					current_clone.find('.business-email').html('<i class="fa fa-envelope"></i> ' + info.email).attr('href', 'mailto:' + info.email);
				}
				if (info.website) {
					current_clone.find('.business-website').html('<i class="fa fa-globe"></i> ' + info.website).attr('href', info.website);
				}
				if (info.address) {
					current_clone.find('.business-address').html('<i class="fa fa-map-marker"></i> ' + info.address + " " + info.suburb + " " + info.state + " " + info.country);
				} else {
					current_clone.find('.map-canvas').hide();
				}

				// check for logo
				if (info.logo != null) {

					// add logo
					current_clone.find('.business-logo').attr("src", info.logo);

				} else {

					// remove logo container
					current_clone.find('.business-logo').parent().remove();

					// change span to be 100%
					current_clone.find('.span:first').attr('class', 'span span10');

				}

				// append to container
				$(business.settings.container).find('.business-container').append(current_clone);

			});

			$(business.settings.container).find('.btn-more-info').click(function() {

				if ($(this).text() == "More Information") {

					// slide the view down
					$(this).parent().find('.business-information').slideDown();

					// change button value
					$(this).text("Less Information");

					var address = $(this).parent().find('.business-address').text();

					var geocoder = new google.maps.Geocoder();

					// Google Map Init
					var mapOptions = {
			          center: new google.maps.LatLng(-34.397, 150.644),
			          zoom: 12
			        };

			        var map = new google.maps.Map($(this).parent().find('.map-canvas')[0], mapOptions);

				    geocoder.geocode({
				    	'address': address
				    }, function(results, status) {

				      if (status == google.maps.GeocoderStatus.OK) {

				        map.setCenter(results[0].geometry.location);
				        map.setZoom(16);
				        var marker = new google.maps.Marker({
				            map: map,
				            position: results[0].geometry.location
				        });

				      } else {
				        $(this).parent().find('.map-canvas').parent().parent().find(".span:first").attr('class', 'span span10');
				      	$(this).parent().find('.map-canvas').hide();
				      }

				    });


				} else {

					// slide the view up
					$(this).parent().find('.business-information').slideUp();

					// change button value
					$(this).text("More Information");

				}

			});

			// search businesses if search is specified
			if (search != undefined && search != "") {

				$(business.settings.container).find('.business').each(function() {

					var found = $(this).find(".business-name:Contains('" + search.toUpperCase() + "')");

					if ($(found).text() == "") {

				        $(this).hide();

			     	} else {

			        	$(this).show();

			      	}

				});

			}


		});

	},

	controls: function() {

		$(business.settings.container).find('.business-categories').find('.business-category').click(function() {

			$(business.settings.container).find('.business-intro-information').hide();
			$(business.settings.container).find('.business-container').show();
			business.print($(this).attr('category-id'));
			$(business.settings.container).find('.category-info-title').html($(this).find('.category-title').text());

		});

		$(business.settings.container).find('.business-return').click(function() {
			$(business.settings.container).find('.business-intro-information').show();
			$(business.settings.container).find('.business-container').hide();
		});

		$(business.settings.container).find('.business-search').keypress(function(e) {

		 	if(e.which == 13) {

		        $(business.settings.container).find('.business-intro-information').hide();
				$(business.settings.container).find('.business-container').show();

				// the search query
				var query = $(this).val();

				// check if query is empty
				if (query == "") {

					// show selected title
					$(business.settings.container).find('.category-info-title').text($(business.settings.container).find('.business-categories').find('option:selected').text());

				} else {

					// change title to search results
					$(business.settings.container).find('.category-info-title').text('Search Results');

				}

				business.print('all', query);

		    }

		});
	}

};
